import React from 'react';

import { useDateFormat } from '@gogame/intl-ts';

import {
  useCreateMainBudgetPlanning,
  useUpdateMainBudgetPlanning,
  useLoadMainBudgetPlanning,
  useIsUpdating,
} from 'scenes/MainBudgetPlanning/data';

import MainBudgetPlanningForm from './MainBudgetPlanningForm';
import { mainBudgetPlanningSchema } from './schemas';

export const MainBudgetPlanningFormCreate = ({
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const [create] = useCreateMainBudgetPlanning();
  const updating = useIsUpdating();

  const handleSubmit = async (values) => {
    const response = await create(values);
    onSubmit(response);
  };

  return (
    <MainBudgetPlanningForm
      title={'Add Period'}
      loading={updating}
      initialValues={mainBudgetPlanningSchema.default()}
      onSubmit={handleSubmit}
      onClose={onClose}
      onExited={onExited}
      open={open}
    />
  );
};

export const MainBudgetPlanningFormEdit = ({
  id,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const { data, isLoading: loading } = useLoadMainBudgetPlanning(id);
  const [update, { isLoading: updating }] = useUpdateMainBudgetPlanning();

  const handleSubmit = async (values) => {
    const response = await update(values);
    onSubmit(response);
  };

  const dateFormat = useDateFormat({ template: 'MONTH' });

  return (
    <MainBudgetPlanningForm
      loading={loading || updating}
      title={'Edit Period'}
      subTitle={dateFormat(data?.period[0])}
      onClose={onClose}
      active={!!data}
      initialValues={data}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
      isEdit={true}
    />
  );
};
